// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"829":"b309a5c0","878":"dfc4d491"}[chunkId] + ".chunk.js";
};